// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { Unit } from './Unit';
/**
 * 元件业务分类 实体类
 * 元件业务分类
 */
export class UnitBizType extends BaseEntity {
  /** 名称 : 名称 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** 编码 : 编码 */
  private _code: string;

  /** 设置：编码 */
  public get code() {
    return this._code;
  }

  /** 获取：编码 */
  public set code(value: string) {
    this._code = value;
  }

  /** 描述 : 描述 */
  private _description: string;

  /** 设置：描述 */
  public get description() {
    return this._description;
  }

  /** 获取：描述 */
  public set description(value: string) {
    this._description = value;
  }

  /** 顺序号 : 顺序号，默认升序排列 */
  private _sequence: number;

  /** 设置：顺序号 */
  public get sequence() {
    return this._sequence;
  }

  /** 获取：顺序号 */
  public set sequence(value: number) {
    this._sequence = value;
  }

  /** 元件 */
  private _units: Array<Unit>;

  /** 获取：元件 */
  public get units() {
    return this._units;
  }

  /** 设置：元件 */
  public set units(value: Array<Unit>) {
    this._units = value;
  }

  /** 上级分类 的ID */
  private _parent_ID: string;

  /** 获取：上级分类 的ID */
  public get parent_ID() {
    return this._parent_ID;
  }

  /** 设置：上级分类 的ID */
  public set parent_ID(value: string) {
    this._parent_ID = value;
  }

  /** 上级分类  */
  private _parent: UnitBizType;

  /** 获取：上级分类  */
  public get parent() {
    return this._parent;
  }

  /** 设置：上级分类  */
  public set parent(value: UnitBizType) {
    this._parent = value;
    if (value !== null) {
      this.parent_ID = value.id;
    } else {
      this.parent_ID = '';
    }
  }

  /** 下级分类 */
  private _children: Array<UnitBizType>;

  /** 获取：下级分类 */
  public get children() {
    return this._children;
  }

  /** 设置：下级分类 */
  public set children(value: Array<UnitBizType>) {
    this._children = value;
  }

  constructor() {
    super();
    this._name = '';
    this._code = '';
    this._description = '';
    this._sequence = 0;
    this._units = new Array<Unit>();
    this._parent_ID = '';
    this._parent = null;
    this._children = new Array<UnitBizType>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: UnitBizType, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.code = element.code;
      this.description = element.description;
      this.sequence = element.sequence;
      this.parent_ID = element.parent_ID;
      if (hasReference && element.parent !== null) {
        this.parent = element.parent;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.code = json.Code;
    this.description = json.Description;
    this.sequence = json.Sequence;
    if (json.Units && json.Units.length > 0) {
      json.Units.forEach((element: any) => {
        const unit = Unit.Create(element);
        // unit.bizType = this;
        this.units.push(unit);
      });
    }
    this.parent_ID = json.Parent_ID;
    // if (json.Parent !== null) {
    //   this.parent = UnitBizType.Create(json.Parent);
    // }
    if (json.Children && json.Children.length > 0) {
      json.Children.forEach((element: any) => {
        const unitBizType = UnitBizType.Create(element);
        // unitBizType.parent = this;
        this.children.push(unitBizType);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.Code = this.code;
    json.Description = this.description;
    json.Sequence = this.sequence;
    if (this.units && this.units.length > 0) {
      json.Units = [];
      this.units.forEach((element) => {
        json.Units.push(element.toJson());
      });
    }
    json.Parent_ID = this.parent_ID;
    if (this.children && this.children.length > 0) {
      json.Children = [];
      this.children.forEach((element) => {
        json.Children.push(element.toJson());
      });
    }
  }

  static Create(json: any): UnitBizType {
    const unitBizType = new UnitBizType();
    unitBizType.Deserialize(json);
    unitBizType.json = json;
    return unitBizType;
  }
}
